module.exports = __webpack_public_path__ + "static/media/emotorbike.764ea4c3.png";